import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import jsPDF from "jspdf";
import "../scss/style.scss";
import Table from "react-bootstrap/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";

export default ({ item, icons, icon, data, html }) => {
  const { lang, database, proxy } = useSelector((state) => state);
  const apiGet = item?.apiGet;
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const svgRef = useRef(null);

  const _token = localStorage.getItem("_token");
  const fetchData = () => {
    setLoading(true);
    fetch(`${proxy()}${apiGet.api_detail.url}/${data?.MaPXK}`, {
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { success, data } = res;
        if (success && data && data?.length > 0) {
          setItems(data);
        }
        handlePDF(data);
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   if (items && items.length > 0 || data?.MaPXK) {
  //     handlePDF();
  //   }
  // }, [items]);

  useEffect(() => {
    let timeout;
    if (loading) {
      Swal.fire({
        title: lang["loading"],
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      timeout = setTimeout(() => {
        Swal.close();
      }, 1000);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [loading]);

  const handlePDF = (props) => {
    const totalSoLuong = props.reduce((total, item) => {
      const soLuong = Number(item.SoLuong);
      return !isNaN(soLuong) ? total + soLuong : total;
    }, 0);
    const totalSoBao = props.reduce((total, item) => {
      const soBao = Number(item.SoBao);
      return !isNaN(soBao) ? total + soBao : total;
    }, 0);

    // const TableView = (
    //   <div
    //     className="page container pt-5 pl-5 pr-5 pb-0"
    //     style={{ width: "210mm" }}
    //   >
    //     <header className="row">
    //       <div className="col-sm-6">
    //         <p className="font-weight-bold font-size-11 m-0">
    //           Đơn vị:....................
    //         </p>
    //         <p className="font-weight-bold font-size-11 m-0">
    //           Bộ phận:................
    //         </p>
    //       </div>
    //       {/* <div className="col-sm-6">
    //         <>
    //           <p className="text-center m-0 font-weight-bold">Mẫu số 02 - VT</p>
    //           <p className="text-center">
    //             (Ban hành theo Thông tư số 132/2018/TT-BTC ngày 28/12/2018 của Bộ
    //             Tài chính)
    //           </p>
    //         </>
    //       </div> */}
    //     </header>
    //     <div className="row">
    //       <div className="col-sm-4"></div>
    //       <div className="col-sm-4 d-flex align-items-center justify-content-center flex-column">
    //         <h1
    //           className="title text-center font-weight-bold"
    //           style={{ fontSize: "14px" }}
    //         >
    //           PHIẾU XUẤT KHO
    //         </h1>
    //         <p className="m-0 font-size-11">{renderDate}</p>
    //         <p className="m-0 font-size-11">Số: {data?.MaPXK}</p>
    //       </div>
    //       <div className="col-sm-4" style={{ marginTop: "2.2rem" }}>
    //         <p className="d-flex justify-content-end mb-0 font-size-11">
    //           Nợ .........................
    //         </p>
    //         <p className="d-flex justify-content-end font-size-11">
    //           Có .........................
    //         </p>
    //       </div>
    //     </div>
    //     <div className="ml-3 mt-2">
    //       <p className="m-0 font-size-11">
    //         - Đơn vị nhận hàng:{" "}
    //         <span>
    //           {data?.PhanPhoiDen
    //             ? data?.PhanPhoiDen
    //             : `............................................................................................................................................................................................`}
    //         </span>
    //       </p>
    //       <p className="m-0 font-size-11">
    //         - Địa chỉ:{" "}
    //         <span>
    //           {data?.DiaChiNPP
    //             ? data?.DiaChiNPP
    //             : `.............................................................................................................................................................................................................`}
    //         </span>
    //       </p>
    //       <p className="m-0 font-size-11">
    //         - Người nhận:{" "}
    //         <span>
    //           {data?.NguoiNhan
    //             ? data?.NguoiNhan
    //             : `......................................................................................................................................................................................................`}
    //         </span>
    //       </p>
    //       <div className="d-flex">
    //         <p className="w-50 m-0 font-size-11">
    //           - Phương tiện:{" "}
    //           <span>
    //             {data?.PhuongTien
    //               ? data?.PhuongTien
    //               : `............................................................................................
    //       `}
    //           </span>
    //         </p>
    //         <p className="m-0 font-size-11">
    //           Biển số:{" "}
    //           <span>
    //             {data?.BienSo
    //               ? data?.BienSo
    //               : `...........................................................................................`}
    //           </span>
    //         </p>
    //       </div>
    //       <p className="m-0 font-size-11">
    //         - Lý do xuất kho:
    //         .................................................................................................................................................................................................
    //       </p>
    //       <p className="m-0 font-size-11">
    //         - Xuất tại kho (ngăn lô):
    //         ..............................................................................Địa
    //         điểm.........................................................................................
    //       </p>
    //     </div>
    //     <div className="w-100 d-flex justify-content-center">
    //       <Table
    //         className="mt-2"
    //         style={{
    //           width: "95%",
    //         }}
    //       >
    //         <thead>
    //           <tr>
    //             <th
    //               className="font-weight-bold font-size-11"
    //               rowSpan={2}
    //               style={{
    //                 alignContent: "center",
    //                 whiteSpace: "nowrap",
    //                 width: "1%",
    //               }}
    //             >
    //               STT
    //             </th>
    //             <th
    //               className="font-weight-bold font-size-11"
    //               rowSpan={2}
    //               style={{
    //                 width: "20%",
    //                 alignContent: "center",
    //               }}
    //             >
    //               Tên, nhãn hiệu, quy cách, phẩm chất vật tư, sản phẩm, hàng hoá
    //             </th>
    //             <th
    //               className="font-weight-bold font-size-11"
    //               rowSpan={2}
    //               style={{
    //                 alignContent: "center",
    //                 whiteSpace: "nowrap",
    //                 width: "1%",
    //               }}
    //             >
    //               Số lệnh giao hàng
    //             </th>
    //             <th className="font-weight-bold font-size-11" colspan={2}>
    //               Số lượng
    //             </th>
    //             <th
    //               className="font-weight-bold font-size-11"
    //               rowSpan={2}
    //               style={{
    //                 alignContent: "center",
    //                 whiteSpace: "nowrap",
    //                 width: "25%",
    //               }}
    //             >
    //               Ghi chú
    //             </th>
    //           </tr>
    //           <tr>
    //             <td
    //               className="font-weight-bold font-size-11"
    //               style={{
    //                 whiteSpace: "nowrap",
    //                 width: "1%",
    //               }}
    //             >
    //               Số Tấn
    //             </td>
    //             <td
    //               className="font-weight-bold font-size-11"
    //               style={{
    //                 whiteSpace: "nowrap",
    //                 width: "1%",
    //               }}
    //             >
    //               Số bao
    //             </td>
    //           </tr>
    //         </thead>
    //         <tbody>
    //           {props &&
    //             props.length > 0 &&
    //             props.map((item, index) => {
    //               const { MaSP, TenSP, MaLGH, SoLuong, SoBao } = item;
    //               return (
    //                 <tr key={index}>
    //                   <td className="align-center font-size-11">{index + 1}</td>
    //                   <td className="align-center font-size-11">
    //                     {TenSP ? `${TenSP}-` : ""} {MaSP || ""}
    //                   </td>
    //                   <td className="align-center font-size-11">{MaLGH}</td>
    //                   <td className="align-center font-size-11">
    //                     {SoLuong !== null && SoLuong !== undefined
    //                       ? Number.isInteger(SoLuong)
    //                         ? SoLuong
    //                         : SoLuong.toFixed(2)
    //                       : ""}
    //                   </td>
    //                   <td className="align-center font-size-11">
    //                     {/* {SoBao !== null && SoBao !== undefined
    //                       ? Number.isInteger(SoBao)
    //                         ? SoBao
    //                         : SoBao.toFixed(2)
    //                       : ""} */}
    //                   </td>
    //                   <td className="align-center font-size-11">
    //                     {data?.GhiChu}
    //                   </td>
    //                 </tr>
    //               );
    //             })}
    //           <tr className="total">
    //             <td
    //               colSpan={3}
    //               className="align-center font-weight-bold font-size-11"
    //             >
    //               Tổng cộng
    //             </td>
    //             <td className="align-center font-weight-bold font-size-11">
    //               {totalSoLuong !== null && totalSoLuong !== undefined
    //                 ? Number.isInteger(totalSoLuong)
    //                   ? totalSoLuong
    //                   : totalSoLuong.toFixed(2)
    //                 : ""}
    //             </td>
    //             <td className="align-center font-weight-bold font-size-11">
    //               {/* {totalSoBao !== null && totalSoBao !== undefined
    //                 ? Number.isInteger(totalSoBao)
    //                   ? totalSoBao
    //                   : totalSoBao.toFixed(2)
    //                 : ""} */}
    //             </td>
    //             <td className="align-center"></td>
    //           </tr>
    //         </tbody>
    //       </Table>
    //     </div>
    //     <div className="ml-5">
    //       <p className="m-0 font-size-11">
    //         - Số lượng (viết bằng chữ):
    //         .......................................................................................................................................................................
    //       </p>
    //     </div>
    //     <footer className="mt-2">
    //       <div className="row">
    //         <div className="sign col-sm-3 text-center">
    //           <span className="font-weight-bold font-size-11">
    //             Người lập phiếu
    //           </span>
    //           <i className="font-size-11" style={{ fontStyle: "italic" }}>
    //             (Ký, ghi rõ họ tên)
    //           </i>
    //         </div>
    //         <div className="sign col-sm-3 text-center">
    //           <span className="font-weight-bold font-size-11">
    //             Người nhận hàng
    //           </span>
    //           <i className="font-size-11" style={{ fontStyle: "italic" }}>
    //             (Ký, ghi rõ họ tên)
    //           </i>
    //         </div>
    //         <div className="sign col-sm-3 text-center">
    //           <span className="font-weight-bold font-size-11">Thủ kho</span>

    //           <i className="font-size-11" style={{ fontStyle: "italic" }}>
    //             (Ký, ghi rõ họ tên)
    //           </i>
    //         </div>
    //         <div className="sign col-sm-3 text-center">
    //           <span className="font-weight-bold font-size-11">Giám đốc</span>
    //           <i className="font-size-11" style={{ fontStyle: "italic" }}>
    //             (Ký, ghi rõ họ tên)
    //           </i>
    //         </div>
    //       </div>
    //     </footer>
    //   </div>
    // );
    const TableView = (
      <div
        className="page container pt-5 pl-5 pr-5 pb-0"
        style={{ width: "210mm" }}
      >
        <header className="d-flex">
          <div className="logo">
            <img src="/images/logo/pvcfclogo.png" alt="logo" width="100px" />
          </div>
          <div className="info">
            <p>
              <strong>
                TỔNG CÔNG TY PHÂN BÓN VÀ HÓA CHẤT DẦU KHÍ - CTCP CHI NHÁNH TỔNG
                CÔNG TY PHÂN BÓN VÀ HÓA CHẤT DẦU KHÍ - CTCP - NHÀ MÁY ĐẠM PHÚ MỸ
              </strong>
            </p>

            <p>Địa chỉ: Khu CN Phú Mỹ 1, Phường Phú Mỹ, Thị xã Phú Mỹ</p>
            <p>
              Điện thoại: (+84) 0254 3 921 468 - Fax: (+84) 0254 3 921 477 -{" "}
              <span>
                Website:{" "}
                <a style={{ color: "black" }} href="https://www.dpm.vn">
                  www.dpm.vn
                </a>
              </span>
            </p>
            <p>
              <strong>Mã số thuế: 0303165480 - 001</strong>
            </p>
          </div>
        </header>
        <hr />
        <div className="row">
          <div className="col-sm-4"></div>
          <div className="col-sm-4 d-flex align-items-center justify-content-center flex-column">
            <h1
              className="title text-center font-weight-bold"
              style={{ fontSize: "14px" }}
            >
              PHIẾU XUẤT KHO
            </h1>
            <p className="m-0 font-size-11">{renderDate}</p>
            <p className="m-0 font-size-11">Số: {data?.MaPXK}</p>
          </div>
          <div className="col-sm-4  second d-flex flex-column align-items-end">
            <img
              width={80}
              src={`https://api.qrserver.com/v1/create-qr-code/?data=${data?.MaPXK}`}
              alt="logo"
            />

            {/* <p className="d-flex justify-content-end mb-0 font-size-11">
              Nợ .........................
            </p>
            <p className="d-flex justify-content-end font-size-11">
              Có .........................
            </p> */}
          </div>
        </div>
        <div className="ml-3 mt-2">
          <p className="m-0 font-size-11">
            - Đơn vị nhận hàng:{" "}
            <span>
              {data?.PhanPhoiDen
                ? data?.PhanPhoiDen
                : `............................................................................................................................................................................................`}
            </span>
          </p>
          <p className="m-0 font-size-11">
            - Địa chỉ:{" "}
            <span>
              {data?.DiaChiNPP
                ? data?.DiaChiNPP
                : `.............................................................................................................................................................................................................`}
            </span>
          </p>
          <p className="m-0 font-size-11">
            - Người nhận:{" "}
            <span>
              {data?.NguoiNhan
                ? data?.NguoiNhan
                : `......................................................................................................................................................................................................`}
            </span>
          </p>
          <div className="d-flex">
            <p className="w-50 m-0 font-size-11">
              - Phương tiện:{" "}
              <span>
                {data?.PhuongTien
                  ? data?.PhuongTien
                  : `............................................................................................
           `}
              </span>
            </p>
            <p className="m-0 font-size-11">
              Biển số:{" "}
              <span>
                {data?.BienSo
                  ? data?.BienSo
                  : `...........................................................................................`}
              </span>
            </p>
          </div>
          <p className="m-0 font-size-11">
            - Lý do xuất kho:
            .................................................................................................................................................................................................
          </p>
          <p className="m-0 font-size-11">
            - Xuất tại kho (ngăn lô):
            ..............................................................................Địa
            điểm.........................................................................................
          </p>
        </div>
        <div className="w-100 d-flex justify-content-center">
          <Table
            className="mt-2"
            style={{
              width: "95%",
            }}
          >
            <thead>
              <tr>
                <th
                  className="font-weight-bold font-size-11"
                  rowSpan={2}
                  style={{
                    alignContent: "center",
                    whiteSpace: "nowrap",
                    width: "1%",
                  }}
                >
                  STT
                </th>
                <th
                  className="font-weight-bold font-size-11"
                  rowSpan={2}
                  style={{
                    width: "20%",
                    alignContent: "center",
                  }}
                >
                  Tên, nhãn hiệu, quy cách, phẩm chất vật tư, sản phẩm, hàng hoá
                </th>
                <th
                  className="font-weight-bold font-size-11"
                  rowSpan={2}
                  style={{
                    alignContent: "center",
                    whiteSpace: "nowrap",
                    width: "1%",
                  }}
                >
                  Số lệnh giao hàng
                </th>
                <th className="font-weight-bold font-size-11" colspan={2}>
                  Số lượng
                </th>
                <th
                  className="font-weight-bold font-size-11"
                  rowSpan={2}
                  style={{
                    alignContent: "center",
                    whiteSpace: "nowrap",
                    width: "25%",
                  }}
                >
                  Ghi chú
                </th>
              </tr>
              <tr>
                <td
                  className="font-weight-bold font-size-11"
                  style={{
                    whiteSpace: "nowrap",
                    width: "1%",
                  }}
                >
                  Số Tấn
                </td>
                <td
                  className="font-weight-bold font-size-11"
                  style={{
                    whiteSpace: "nowrap",
                    width: "1%",
                  }}
                >
                  Số bao
                </td>
              </tr>
            </thead>
            <tbody>
              {props &&
                props.length > 0 &&
                props.map((item, index) => {
                  const { MaSP, TenSP, MaLGH, SoLuong, SoBao } = item;
                  return (
                    <tr key={index}>
                      <td className="align-center font-size-11">{index + 1}</td>
                      <td className="align-center font-size-11">
                        {TenSP ? `${TenSP}-` : ""} {MaSP || ""}
                      </td>
                      <td className="align-center font-size-11">{MaLGH}</td>
                      <td className="align-center font-size-11">
                        {SoLuong !== null && SoLuong !== undefined
                          ? Number.isInteger(SoLuong)
                            ? SoLuong
                            : SoLuong.toFixed(2)
                          : ""}
                      </td>
                      <td className="align-center font-size-11">
                        {/* {SoBao !== null && SoBao !== undefined
                           ? Number.isInteger(SoBao)
                             ? SoBao
                             : SoBao.toFixed(2)
                           : ""} */}
                      </td>
                      <td className="align-center font-size-11">
                        {data?.GhiChu}
                      </td>
                    </tr>
                  );
                })}
              <tr className="total">
                <td
                  colSpan={3}
                  className="align-center font-weight-bold font-size-11"
                >
                  Tổng cộng
                </td>
                <td className="align-center font-weight-bold font-size-11">
                  {totalSoLuong !== null && totalSoLuong !== undefined
                    ? Number.isInteger(totalSoLuong)
                      ? totalSoLuong
                      : totalSoLuong.toFixed(2)
                    : ""}
                </td>
                <td className="align-center font-weight-bold font-size-11">
                  {/* {totalSoBao !== null && totalSoBao !== undefined
                     ? Number.isInteger(totalSoBao)
                       ? totalSoBao
                       : totalSoBao.toFixed(2)
                     : ""} */}
                </td>
                <td className="align-center"></td>
              </tr>
            </tbody>
          </Table>
        </div>
        <div className="ml-5">
          <p className="m-0 font-size-11">
            - Số lượng (viết bằng chữ):
            .......................................................................................................................................................................
          </p>
        </div>
        <footer className="mt-2">
          <div className="row">
            <div className="sign col-sm-3 text-center">
              <span className="font-weight-bold font-size-11">
                Người lập phiếu
              </span>
              <i className="font-size-11" style={{ fontStyle: "italic" }}>
                (Ký, ghi rõ họ tên)
              </i>
            </div>
            <div className="sign col-sm-3 text-center">
              <span className="font-weight-bold font-size-11">
                Người nhận hàng
              </span>
              <i className="font-size-11" style={{ fontStyle: "italic" }}>
                (Ký, ghi rõ họ tên)
              </i>
            </div>
            <div className="sign col-sm-3 text-center">
              <span className="font-weight-bold font-size-11">Thủ kho</span>

              <i className="font-size-11" style={{ fontStyle: "italic" }}>
                (Ký, ghi rõ họ tên)
              </i>
            </div>
            <div className="sign col-sm-3 text-center">
              <span className="font-weight-bold font-size-11">Giám đốc</span>
              <i className="font-size-11" style={{ fontStyle: "italic" }}>
                (Ký, ghi rõ họ tên)
              </i>
            </div>
          </div>
        </footer>
      </div>
    );
    const element = document.createElement("div");
    ReactDOM.render(TableView, element);

    const doc = new jsPDF({
      orientation: "p",
      format: "a4",
      unit: "px",
      hotfixes: ["px_scaling"],
    });

    doc.addFont(
      "/fonts/Times New Roman/TIMES.ttf",
      "Times New Roman",
      "normal"
    );
    doc.addFont(
      "/fonts/Times New Roman/TIMESBD.ttf",
      "Times New Roman",
      "bold"
    );
    doc.addFont(
      "/fonts/Times New Roman/TIMESI.ttf",
      "Times New Roman",
      "italic"
    );
    doc.setFont("Times New Roman", "italic");
    doc.setFont("Times New Roman", "normal");
    doc.setFont("Times New Roman", "bold");

    doc.html(element, {
      callback: function (doc) {
        // window.open(doc.output("bloburl"), "_blank");
        doc.save(`${data?.MaPXK}.pdf`);
      },
    });
  };
  const date = new Date();
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();
  const pMonth = month.toString().padStart(2, "0");
  const pDay = day.toString().padStart(2, "0");
  const renderDate = `Ngày ${pDay} tháng ${pMonth} năm ${year}`;

  return (
    // <TableView />
    <>
      <div onClick={() => fetchData()}>
        <FontAwesomeIcon
          icon={icons[icon]?.icon}
          title={item?.title ? item?.title : lang["redirect_button"]}
        />
      </div>
    </>
  );
};
